import { ReactNode } from 'react';

import { PrimaryButton } from '@/components/buttons';

import clsx from 'clsx';

type SubmitButtonProps = {
  children: ReactNode;
  isVertical?: boolean;
  disabled?: boolean;
};

export default function SubmitButton({
  isVertical,
  disabled,
  children,
}: SubmitButtonProps) {
  return (
    <div className={clsx('flex justify-end', !isVertical && 'md:col-span-2')}>
      <PrimaryButton
        className="w-full mt-2 sm:w-fit"
        data-testid="btn-submit-signup"
        disabled={disabled}
        type="submit"
      >
        {children}
      </PrimaryButton>
    </div>
  );
}
